const arrow = require("./arrow.png");
const back = require("./back.png");
const close = require("./close.png");
const cross = require("./cross.png");
const dropdown = require("./dropdown.png");
const notch = require("./notch.png");
const notchRound = require("./notch_round.png");
const plus = require("./plus.png");
const shadow = require("./shadow.png");
const wave = require("./wave.png");
const rectangle = require("./Forme-de-votre-piscine_Rectangle.png");
const libre = require("./Forme-de-votre-piscine_Libre-ou-complexe.png");
const plat = require("./Fond-de-votre-piscine_Plat.png");
const douce = require("./Fond-de-votre-piscine_Pente-douce.png");
const composee = require("./Fond-de-votre-piscine_Pente-composee.png");
const diamant = require("./Fond-de-votre-piscine_Pointe-diamant.png");
const fin = require("./Type-de-debris-frequemment-collectes_FinsMoyens.png");
const gros = require("./Type-de-debris-frequemment-collectes_GrosTres-gros.png");
const freedomLite = require("./FREEDOM-FREEDOM-LITE.png"); 
const freedomcontrol = require("./FREEDOM-CONTROL.png"); 
const freedomrf42iQ = require("./FREEDOM-RF-42-iQ.png");
const rf5200iQ = require("./FREERIDER-RF-5200-iQ.png"); 
const rf5400iQ = require("./FREERIDER-RF-5400-iQ.png");
const rf5600iQ = require("./FREERIDER-RF-5600-iQ.png");
const rf42iQ = require("./FREERIDER-RF-42-iQ.png");
const ot2100 = require("./Tornax-OT-2100.png");
const ot3200 = require("./Tornax-OT-3200.png");
const ot3200Tile = require("./Tornax-OT-3200-TILE.png");
const ot3240 = require("./Tornax-OT-3240.png");
const ot3300 = require("./Tornax-OT-3300.png");
const ov3400 = require("./Vortex-2WD-OV-3400.png");
const ov3480 = require("./Vortex-2WD-OV-3480.png");
const ov3500 = require("./Vortex-2WD-OV-3500.png");
const ov3505 = require("./Vortex-2WD-OV-3505.png");
const ov2wd5200 = require("./Vortex-2WD-OV-5200.png");
const ov5200 = require("./Vortex-4WD-OV-5200.png");
const ov5300 = require("./Vortex-4WD-OV-5300-SW.png");
const ov5480 = require("./Vortex-4WD-OV-5480-IQ.png");
const oa6400iq = require("./Alpha-iQ-OA-6400-iQ.png");
const oa6600iq = require("./Alpha-iQ-OA-6600-iQ.png");
const ra6300iQ = require("./Alpha-iQ-RA-6300-iQ.png");
const ra6300 = require("./Alpha-iQ-tm-RA-6300-iQ.png");
const ra6500 = require("./Alpha-iQ-tm-RA-6500-iQ.png");
const ra6700iQ = require("./Alpha-iQ-RA-6700-iQ.png");
const ra6700 = require("./Alpha-iQ-tm-RA-6700-iQ.png");
const ra6800iQ = require("./Alpha-iQ-RA-6800-iQ.png");
const ra6900iQ = require("./Alpha-iQ-RA-6900-iQ.png");
const rc4300 = require("./CyclonX-RC-4300.png");
const rc4380 = require("./CyclonX-RC-4380.png");
const rc4400 = require("./CyclonX-RC-4400.png");
const rc4402 = require("./CyclonX-RC-4402.png");
const rt2100 = require("./Tornax-RT-2100.png");
const rt3200 = require("./Tornax-RT-3200.png");
const rv5300 = require("./Vortex-4WD-RV-5300.png");
const rv5380 = require("./Vortex-4WD-RV-5380.png");
const rv5600 = require("./Vortex-4WD-RV-5600.png");
const cnx10 = require("./CNX-CNX-10.jpg");
const cnx20 = require("./CNX-CNX-20.jpg");
const cnx25 = require("./CNX-CNX-25.png");
const cnx30iQ = require("./CNX-CNX-30-IQ.jpg");
const cnx40iQ = require("./CNX-CNX-40-iQ.png");
const cnx50iQ = require("./CNX-CNX-50-iQ.png");
const cnxLi52iQ = require("./FREEDOM-CNX-Li-52-iQ.png");
const of42iQ = require("./FREEDOM-OF-42-iQ.png");
const re4100 = require("./Voyager-RE-4100.jpg");
const re4200 = require("./Voyager-RE-4200.jpg");
const re4300 = require("./Voyager-RE-4300.png");
const re4400iQ = require("./Voyager-RE-4400-IQ.png");
const re4600iQ = require("./Voyager-RE-4600-IQ.png");
const re4700iQ = require("./Voyager-RE-4700-iQ.png");
const rg3200 = require("./Tornax-RG-3200-TILE.png");
const swy3500 = require("./SWEEPY-SWY-3500.jpg");
const opLi2100 = require("./PIXEL-OP-Li-2100.jpg");
const op32 = require("./PIXEL-OP-32.png");
const no_robot = require("./no_robot.png");

export default {
  arrow,
  back,
  cross,
  close,
  dropdown,
  notch,
  notchRound,
  plus,
  shadow,
  wave,
  no_robot,
  "Forme-de-votre-piscine_Rectangle": rectangle,
  5: rectangle,
  "Forme-de-votre-piscine_Libre-ou-complexe": libre,
  6: libre,
  "Fond-de-votre-piscine_Plat": plat,
  15: plat,
  "Fond-de-votre-piscine_Pente-douce": douce,
  16: douce,
  "Fond-de-votre-piscine_Pente-composee": composee,
  17: composee,
  "Fond-de-votre-piscine_Pointe-diamant": diamant,
  18: diamant,
  "Type-de-debris-frequemment-collectes_FinsMoyens": fin,
  13: fin,
  "Type-de-debris-frequemment-collectes_GrosTres-gros": gros,
  14: gros,
  "Tornax-OT-2100": ot2100,
  "Tornax-OT-3200": ot3200,
  "Tornax-OT-3200-TILE": ot3200Tile,
  "Tornax-OT-3240": ot3240,
  "Tornax-OT-3300": ot3300,
  "Vortex-2WD-OV-3400": ov3400,
  "Vortex-2WD-OV-3480": ov3480,
  "Vortex-2WD-OV-3500": ov3500,
  "Vortex-2WD-OV-3505": ov3505,
  "Vortex-2WD-OV-5200": ov2wd5200,
  "Vortex-4WD-OV-5200": ov5200,
  "Vortex-4WD-OV-5300-SW": ov5300,
  "Vortex-4WD-OV-5480-iQ": ov5480,
  "Alpha-iQ-OA-6400-iQ" : oa6400iq,
  "Alpha-iQ-OA-6600-iQ" : oa6600iq,
  "Alpha-iQ-RA-6300-iQ": ra6300iQ,
  "Alpha-iQ-tm-RA-6300-iQ": ra6300,
  "Alpha-iQ-tm-RA-6500-iQ": ra6500,
  "Alpha-iQ-RA-6500-iQ": ra6500,
  "Alpha-iQ-tm-RA-6700-iQ": ra6700,
  "Alpha-iQ-RA-6700-iQ": ra6700iQ,
  "Alpha-iQ-RA-6800-iQ": ra6800iQ,
  "Alpha-iQ-RA-6900-iQ": ra6900iQ,
  "CyclonX-RC-4300": rc4300,
  "CyclonX-RC-4380": rc4380,
  "CyclonX-RC-4400": rc4400,
  "CyclonX-RC-4402": rc4402,
  "Cyclonix-RC-4402": rc4402,
  "Tornax-RT-2100": rt2100,
  "Tornax-RT-2100-TILE": rt2100,
  "Tornax-RT-3200": rt3200,
  "Vortex-4WD-RV-5300": rv5300,
  "Vortex-4WD-RV-5380": rv5380,
  "Vortex-4WD-RV-5600": rv5600,
  "CNX-CNX-10": cnx10,
  "CNX-CNX-20": cnx20,
  "CNX-CNX-25": cnx25,
  "CNX-CNX-30-iQ": cnx30iQ,
  "CNX-CNX-40-iQ": cnx40iQ,
  "CNX-CNX-50-iQ": cnx50iQ,
  "Voyager-RE-4100": re4100,
  "Voyager-RE-4200": re4200,
  "Voyager-RE-4300": re4300,
  "Voyager-RE-4400-iQ": re4400iQ,
  "Voyager-RE-4600-iQ": re4600iQ,
  "Voyager-RE-4700-iQ": re4700iQ,
  "Tornax-RG-3200-TILE": rg3200,
  "Tornax-RG-3200": rg3200,
  "FREEDOM-RF-42-iQ" : freedomrf42iQ,
  "FREEDOM-FREEDOM-LITE" : freedomLite,
  "FREEDOM-FREEDOM+-CONTROL" : freedomcontrol,
  "FREERIDER-RF-5400-iQ": rf5400iQ,
  "FREERIDER-RF-5200-iQ": rf5200iQ,
  "FREERIDER-RF-5600-iQ": rf5600iQ,
  "FREERIDER-RF-42-iQ": rf42iQ,
  "SWEEPY-SWY-3500": swy3500,
  "FREEDOM-CNX-Li-52-iQ": cnxLi52iQ,
  "FREEDOM-OF-42-iQ" : of42iQ,
  "PIXEL-OP-Li-2100": opLi2100,
  "PIXEL-OP-32": op32
};
